var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.442,
    height: 188.442,
    viewBox: "0 0 188.442 188.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1307",
    "data-name": "Raggruppa 1307",
    transform: "translate(1.583 1.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2876",
    "data-name": "Tracciato 2876",
    d: "M56.063,26.333v75.134m0-75.134c-6.576,0-18.863,18.73-23.479,23.479M56.063,26.333c6.576,0,18.863,18.73,23.479,23.479",
    transform: "translate(36.576 28.738)",
    fill: "none",
    stroke: "#141b34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2877",
    "data-name": "Tracciato 2877",
    d: "M3.417,92.638c0-42.059,0-63.089,13.066-76.155S50.578,3.417,92.638,3.417s63.089,0,76.156,13.066,13.066,34.1,13.066,76.155,0,63.089-13.066,76.156-34.1,13.066-76.156,13.066-63.089,0-76.155-13.066S3.417,134.7,3.417,92.638Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#141b34",
    strokeWidth: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e03204f46e7b9ca291a753eb4697e4bb.svg";
export { ForwardRef as ReactComponent };